import RepairJobIndicator from '@/modules/crypto-assets/components/RepairJobIndicator'
import React from 'react'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import Home from '@/pages/Home'
import HomeEntry from '@/modules/navigation/components/HomeEntry'
import { ToastProvider } from '@/shared/ui/Toast'
import LoginPage from '@/modules/auth/pages/LoginPage'
import SignupPage from '@/modules/auth/pages/SignupPage'
import VipRegisterPage from '@/modules/auth/pages/VipRegisterPage'
import AffiliateRegisterPage from '@/modules/auth/pages/AffiliateRegisterPage'
import ResetPasswordPage from '@/modules/auth/pages/ResetPasswordPage'
import PublicOnly from '@/modules/auth/routes/PublicOnly'
import { AuthProvider } from '@/modules/auth/context/AuthContext'
import Protected from '@/modules/auth/routes/Protected'
import ProfilePage from '@/modules/profile/pages/ProfilePage'
import DashboardMasterPage from '@/modules/dashboard-master/pages/DashboardMasterPage'
import DesignSystemPage from '@/modules/dashboard-master/pages/DesignSystemPage'
import { CustomersPage } from '@/modules/customer'
import AccessDeniedPage from '@/pages/AccessDenied'
import DashboardAffiliatePage from '@/modules/dashboard-affiliate/pages/DashboardAffiliatePage'
import MyRecebimentosPage from '@/modules/affiliates/pages/MyRecebimentosPage'
import MyAfiliacoesPage from '@/modules/affiliates/pages/MyAfiliacoesPage'
import MyComissoesPage from '@/modules/affiliates/pages/MyComissoesPage'
import MyCouponsPage from '@/modules/affiliates/pages/MyCouponsPage'
import { AffiliatesPage } from '@/modules/affiliates'
import AffiliateDetailsPage from '@/modules/affiliates/pages/AffiliateDetailsPage'
import { PlansPage, MemberPlansPage } from '@/modules/plans'
import SettingsPage from '@/modules/settings/pages/SettingsPage'
import ReportsPage from '@/modules/reports/pages/ReportsPage'
import RelatorioV2Page from '@/modules/relatorio-v2/pages/RelatorioV2Page'
import VipAdminPage from '@/modules/vip/pages/VipAdminPage'
import { AuditoriaPage } from '@/modules/auditoria'
import TestimonialsAdminPage from '@/modules/testimonials/pages/TestimonialsAdminPage'
import { FaqAdminPage } from '@/modules/faq'
import { CheckoutPage, ThankYouPage } from '@/modules/checkout/pages'
import SubscriptionsPage from '@/modules/subscriptions/pages/SubscriptionsPage'
import SubscriptionsV2Page from '@/modules/subscriptions/pages/SubscriptionsV2Page'
import MemberInvoicesPage from '@/modules/billing/pages/MemberInvoicesPage'
import FinancePage from '@/modules/finance/pages/FinancePage'
import EvolucoesPage from '@/modules/evolucoes/pages/EvolucoesPage'
import OportunidadesPage from '@/modules/oportunidades/pages/OportunidadesPage'
import MobileOpportunitySheetPage from '@/modules/oportunidades/pages/MobileOpportunitySheetPage'
import AnaliseCriptoPage from '@/modules/analises/pages/AnaliseCriptoPage'
import VisoesPage from '@/modules/visoes/pages/VisoesPage'
import ChatPage from '@/modules/chat/pages/ChatPage'
import RewardsEntryPage from '@/modules/rewards/pages/RewardsEntryPage'
import RewardsMasterPage from '@/modules/rewards/pages/RewardsMasterPage'
import CouponsAdminPage from '@/modules/discount-coupons/pages/CouponsAdminPage'
import SugestoesPage from '@/modules/sugestoes/pages/SugestoesPage'
import RepassesPage from '@/modules/revshare/pages/RepassesPage'
import RevshareParticipantDetailsPage from '@/modules/revshare/pages/RevshareParticipantDetailsPage'
import { MaintenanceGate } from '@/modules/maintenance/components/MaintenanceGate'
import AppLauncher from '@/modules/pwa/pages/AppLauncher'
import ManageAppPage from '@/modules/pwa/pages/ManageAppPage'
import PushOptInModal from '@/modules/pwa/components/PushOptInModal'
import UserSettingsEntry from '@/modules/user-settings/pages/UserSettingsEntry'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { captureReferralFromLocation } from '@/modules/affiliates/services/referralService'
import { ChristmasSnowLayer } from '@/modules/natal'
import AffiliateLandingPage from '@/modules/affiliates/pages/AffiliateLandingPage'

function ReferralCapture() {
  const loc = useLocation()
  useEffect(() => { try { captureReferralFromLocation(window.location) } catch {} }, [loc.search])
  return null
}


export default function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <BrowserRouter>
          <MaintenanceGate>
          {/** Captura ref=? e guarda por 30 dias */}
          <ReferralCapture />
          <Routes>
            <Route path="/" element={<HomeEntry />} />
            <Route path="/app" element={<AppLauncher />} />
            <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
            <Route path="/reset-password" element={<PublicOnly><ResetPasswordPage /></PublicOnly>} />
            <Route path="/cadastro" element={<PublicOnly><SignupPage /></PublicOnly>} />
            <Route path="/vip" element={<PublicOnly><VipRegisterPage /></PublicOnly>} />
            <Route path="/afiliado" element={<PublicOnly><AffiliateRegisterPage /></PublicOnly>} />
            <Route path="/seja-afiliado" element={<AffiliateLandingPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/obrigado" element={<ThankYouPage />} />
            <Route
              path="/profile"
              element={
                <Protected roles={["member","master","afiliado"]}>
                  <ProfilePage />
                </Protected>
              }
            />
            <Route
              path="/gerenciar-app"
              element={
                <Protected roles={["member","master","afiliado"]}>
                  <ManageAppPage />
                </Protected>
              }
            />
            <Route
              path="/dashboard-master"
              element={
                <Protected roles={["master"]}>
                  <DashboardMasterPage />
                </Protected>
              }
            />
            <Route
              path="/admin/design-system"
              element={
                <Protected roles={["master"]}>
                  <DesignSystemPage />
                </Protected>
              }
            />
            <Route
              path="/dashboard-affiliate"
              element={
                <Protected roles={["afiliado"]}>
                  <DashboardAffiliatePage />
                </Protected>
              }
            />
            <Route
              path="/afiliacoes"
              element={
                <Protected roles={["afiliado"]}>
                  <MyAfiliacoesPage />
                </Protected>
              }
            />
            <Route
              path="/comissoes"
              element={
                <Protected roles={["afiliado"]}>
                  <MyComissoesPage />
                </Protected>
              }
            />
            <Route
              path="/meus-cupons"
              element={
                <Protected roles={["afiliado"]}>
                  <MyCouponsPage />
                </Protected>
              }
            />
            <Route
              path="/recebimentos"
              element={
                <Protected roles={["afiliado"]}>
                  <MyRecebimentosPage />
                </Protected>
              }
            />
            <Route
              path="/customers"
              element={
                <Protected roles={["master"]}>
                  <CustomersPage />
                </Protected>
              }
            />
            <Route
              path="/affiliates"
              element={
                <Protected roles={["master"]}>
                  <AffiliatesPage />
                </Protected>
              }
            />
            <Route
              path="/affiliates/:id"
              element={
                <Protected roles={["master"]}>
                  <AffiliateDetailsPage />
                </Protected>
              }
            />
            <Route
              path="/plans"
              element={
                <Protected roles={["master"]}>
                  <PlansPage />
                </Protected>
              }
            />
            <Route
              path="/cupons"
              element={
                <Protected roles={["master"]}>
                  <CouponsAdminPage />
                </Protected>
              }
            />
            <Route
              path="/vip-admin"
              element={
                <Protected roles={["master"]}>
                  <VipAdminPage />
                </Protected>
              }
            />
            <Route
              path="/subscriptions"
              element={
                <Protected roles={["master"]}>
                  <SubscriptionsPage />
                </Protected>
              }
            />
            <Route
              path="/subscriptions-v2"
              element={
                <Protected roles={["master"]}>
                  <SubscriptionsV2Page />
                </Protected>
              }
            />
            <Route
              path="/financeiro"
              element={
                <Protected roles={["master"]}>
                  <FinancePage />
                </Protected>
              }
            />
            <Route
              path="/reports"
              element={
                <Protected roles={["master"]}>
                  <ReportsPage />
                </Protected>
              }
            />
            <Route
              path="/relatorio-v2"
              element={
                <Protected roles={["master"]}>
                  <RelatorioV2Page />
                </Protected>
              }
            />
            <Route
              path="/auditoria"
              element={
                <Protected roles={["master"]}>
                  <AuditoriaPage />
                </Protected>
              }
            />
            <Route
              path="/evolucoes"
              element={
                <Protected roles={["master","member","afiliado"]}>
                  <EvolucoesPage />
                </Protected>
              }
            />
            <Route
              path="/oportunidades"
              element={
                <Protected roles={["master","afiliado","member"]}>
                  <OportunidadesPage />
                </Protected>
              }
            />
            <Route
              path="/analise-cripto"
              element={
                <Protected roles={["master","afiliado","member"]}>
                  <AnaliseCriptoPage />
                </Protected>
              }
            />
            <Route
              path="/visoes"
              element={
                <Protected roles={["master","afiliado","member"]}>
                  <VisoesPage />
                </Protected>
              }
            />
            <Route
              path="/chat"
              element={
                <Protected roles={["master","afiliado","member"]}>
                  <ChatPage />
                </Protected>
              }
            />
            <Route
              path="/rewards"
              element={
                <Protected roles={["master","member"]}>
                  <RewardsEntryPage />
                </Protected>
              }
            />
            <Route
              path="/rewards-master-dashboard"
              element={
                <Protected roles={["master"]}>
                  <RewardsMasterPage />
                </Protected>
              }
            />
            <Route
              path="/repasses"
              element={
                <Protected roles={["master","member","afiliado"]}>
                  <RepassesPage />
                </Protected>
              }
            />
            <Route
              path="/repasses/:id"
              element={
                <Protected roles={["master"]}>
                  <RevshareParticipantDetailsPage />
                </Protected>
              }
            />
            <Route
              path="/mobile-opportunity"
              element={
                <Protected roles={["master","afiliado","member"]}>
                  <MobileOpportunitySheetPage />
                </Protected>
              }
            />
            <Route
              path="/sugestoes"
              element={
                <Protected roles={["master","afiliado","member"]}>
                  <SugestoesPage />
                </Protected>
              }
            />
            <Route
              path="/user-settings"
              element={
                <Protected roles={["member","afiliado","master"]}>
                  <UserSettingsEntry />
                </Protected>
              }
            />
            <Route path="/configuracoes" element={<Navigate to="/user-settings" replace />} />
            <Route
              path="/settings"
              element={
                <Protected roles={["master"]}>
                  <SettingsPage />
                </Protected>
              }
            />
            <Route
              path="/testimonials"
              element={
                <Protected roles={["master"]}>
                  <TestimonialsAdminPage />
                </Protected>
              }
            />
            <Route
              path="/faq"
              element={
                <Protected roles={["master"]}>
                  <FaqAdminPage />
                </Protected>
              }
            />
            <Route
              path="/my-plans"
              element={
                <Protected roles={["member"]}>
                  <MemberPlansPage />
                </Protected>
              }
            />
            <Route
              path="/assinatura"
              element={
                <Protected roles={["member"]}>
                  <MemberInvoicesPage />
                </Protected>
              }
            />
            <Route path="/access-denied" element={<AccessDeniedPage />} />
          </Routes>
          </MaintenanceGate>
          {/* Modal de opt-in de Push (master-only, móvel, condicionado) */}
          <PushOptInModal />
          <RepairJobIndicator />
          <ChristmasSnowLayer />
        </BrowserRouter>
      </AuthProvider>
    </ToastProvider>
  )
}
